import React, { useReducer } from "react";
import axios from 'axios';
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import NuInputEdit from "components/nubox/NuInputEdit";

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";
import PagoModal from "views/_box/PagoModal";

import Odontograma from 'components/Odontograma';

import TratamientoDetModal from 'views/_box/TratamientoDetModal'
import user from 'assets/img/user.jpg';
import user1 from 'assets/img2/user1.png';


import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";



const cbo=[
  {  value:'1', label: 'label1'},
  {  value:'2', label: 'Clss'},
  {  value:'3', label: 'Nod'},
  {  value:'4', label: 'Lod'},
  {  value:'5', label: 'Elggg'},
]

const form_reset={
  idd:0,
  ope:'n', 

  id_tra:0,
  nombre:'',
  detalle:'',
  fecha:'',
  mtotal:0,
  pagado:0,
  saldo:0,
  estado:0 	   
}

const data_ini=[
    {
        "id_tradet": 129,
        "fecha": "2025-10-16",
        "id_prod": 5,
        "nombre_p": "EXODONCIA",
        "pieza": "25",
        "partes": "00000",
        "id_medico": 0,
        "color": "#ff0000",
        "interno_sn": 0,
        "cant": 1,
        "precio": 35,
        "descu": 0,
        "total": 35,
        "id_tra": 17,
        "realizado_sn": 0
    }
]

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class Tratamiento extends React.Component {
  
  

  state = {
    modalImagen: false,
    id_paciente: 0,
    id_tra:0,

    form: form_reset,
    //data: data_ini, /* tratamientos_det */
    data:[]

  };
  
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
    this.modalRef = React.createRef();//create ref
    this.modalRefPago = React.createRef();//create ref
  }
  //------------------

  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});

    let id_ = this.props.store.paciente.id_paciente;
    // Get the userId param from the URL.
    let id_tra = this.props.params.idd;
    let ope = this.props.params.ope;  
    //    console.log("id_tra:"+ id_tra);
  
    
      if(ope==='e' || ope==='x'){
        this.cargar_tratamiento(id_tra);
        //this.cargar_odontograma(id_tratamiento);
      }

      if(ope==='n'){
        this.limpiar();
      }

      this.setState({ form:{
          ...this.state.form, 
          idd: id_tra, 
          ope: ope,
        },
        id_paciente: id_,
        id_tra: id_tra,
      }); 
  

  }

  //------------ 
  limpiar(){
    this.setState({form: form_reset, data: []});
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){
      let res = e.target.checked? 1:0;
            
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  
  //---------------------------------
  handleChangeSwitch = (e, id_tradet) => {
    //requerimos la prop name="?" en cada control
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    let res = e.target.checked? 1:0;

    var contador = 0;
    var arreglo = this.state.data;
    //----buscamos la fila, con el id
    arreglo.map((registro) => {
      if (registro.id_tradet == id_tradet) {
        arreglo[contador].realizado_sn = res;
      }
      contador ++;
    });
    this.setState({ data: arreglo, modalActualizar: false });
    //------------------guardamos en la base de datod
    this.saveSwitch(id_tradet, res);
  };
  //---------- cuando hace enter ------------------------
  handleOKInput = (e) => {
    //---- actualizamos el campo detalle
    this.actualizarDetalle(e.target.value);
  };
  //---------------------------------------
  actualizarDetalle =(nombre) =>{
    let param =  {
      id_tra: this.state.id_tra,
      nombre: nombre
    };
    
    axios2.post("tratamiento_update_detalle", param)
    .then(res => {
    
        if(res.data.exito === 1){ 
            toast.success(res.data.mensaje);
        }else{
            toast.error(res.data.mensaje);
        }
  
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
    
  }
  //====================================================== 
  //----cargamos los datos desde la base de datos
  cargar_tratamiento = (id_tra) => {
    
    //context API
    console.log("---cargar tratamiento----");
    
    let param = { 
      id_tra: id_tra
    }
    
    axios2.post( "tratamiento_lista", param).then(res => {
      const response = res.data;
      console.log(response.data);

      if(response.exito===1){ 
        this.setState({
          form: response.form,
          data: response.data,
        });

      }else{
          toast.error("No existen registros");
          this.limpiar();
      }

    }).catch(error => {
        alert("---- Existio un error, ---");
        console.log(error);
        
    });
  };
  //-----------------------------------------------------------
  imprimir =()=>{
    /*let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);*/
    let printContents = document.getElementById('printablediv').innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents; 
  
  }
  //----------------
  liquidar_deuda=()=>{
    this.aceptar_click()
  }


  //-----------------------------------------------
  aceptar_click = async () => {
    console.log("aceptar");
    
      this.refNuConfirm.current.show({ 
      message: '¿Esta seguro de finalizar el tratamiento?',
      title: 'Confirmación',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
          
          //this.save();
          this.saveForm()
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })
 
}
/**************************************************************** */
realizar_pago=()=>{
  let id_tra = this.state.form.id_tra
  
  this.modalRefPago.current.nuevo(id_tra); 
}
okModalPago =()=>{
    console.log("okModal");
    //--------
    //let id_paciente = this.state.id_paciente;
    //this.fetchData(id_paciente);
    let id_tra = this.state.form.id_tra
    this.cargar_tratamiento(id_tra)
  }
closeModalPago =()=>{
  console.log("closeModal");
}
/**************************************************************** */
saveSwitch =(id_tradet, realizado_sn) =>{
  let param =  {
    id_tradet:id_tradet,
    realizado_sn:realizado_sn
  };
  
  axios2.post("tradet_update_realizado", param)
  .then(res => {
  
      if(res.data.exito === 1){ 
          toast.success(res.data.mensaje);
      }else{
          toast.error(res.data.mensaje);
      }

  }).catch(error => {
      alert("---- Existio un error ---");
      console.log(error);
  });
  
}
//----------------------- MODAL *---------------
okModal =()=>{
  console.log("okModal");
  //---------
  let id_tra = this.state.id_tra;
  this.cargar_tratamiento(id_tra);
}
closeModal =()=>{
  console.log("closeModal");
}
//---------------------
agregar_row=()=>{
  //let id_medico = this.state.form.id_medico;
  
  
  if(this.modalRef.current!=null){
    this.modalRef.current.nuevo(); 
  }
}
//----------------
editar_row=( id_tradet) =>{
  if(this.modalRef.current!=null){
    this.modalRef.current.editar(id_tradet); 
  }
}
//---------------------
eliminar_row=( id_tradet) =>{
  if(this.modalRef.current!=null){
    this.modalRef.current.eliminar(id_tradet); 
  }
}
//-------------------ODONTOGRAMA----------------
onClickPieza =(pieza)=>{
  console.log(pieza);

  if(this.modalRef.current!=null){

    
    this.modalRef.current.nuevo(); 
    this.modalRef.current.setPieza(pieza);

  }
}
/**************************************************************** */
saveForm =() =>{
  let id_tra = this.state.form.id_tra
  let param =  {
    id_tra:id_tra,
  };
  
  axios2.post("tratamiento_finalizar_trat", param)
  .then(res => {
  
      if(res.data.exito === 1){ 
          toast.success(res.data.mensaje);
      }else{
          toast.error(res.data.mensaje);
      }

  }).catch(error => {
      alert("---- Existio un error ---");
      console.log(error);
  });
  
}
/******************************************************************** */
//------------------------------------
  render() { 
    //------------ context API --------------
   
    //console.log( process.env.REACT_APP_AFILES + this.state.form.foto_path1 );
    const {form} = this.state;

    return (
      <div>
        <ToastContainer />

        { 
          //JSON.stringify(this.state.id_tra) 
          //JSON.stringify(this.state.form )
        }

        <div className="content1">

          {/* ---   --- */}
          {/* ---   --- */}
          {/*JSON.stringify(this.props.store.paciente)*/}


          <section className="content-header">
            
            <Link to={"/tratamientolist/"+ this.state.id_paciente } className='btn btn-success'>
              <i className='fa fa-plus' aria-hidden='true'></i> Volver
            </Link>
            
            <div className="btn-group pull-right">

              <Button onClick={ this.imprimir } className="create-modal btn btn-info ">
                <i className="fa fa-print"></i> Imprimir
              </Button>
              <Button className="create-modal btn btn-danger" 
                onClick={ this.liquidar_deuda }>
                <i className="fa fa-fw fa-close"></i> Finalizar Trat.
              </Button>
            </div>
          </section>




        </div>

        <section className="content" id='printablediv'>
          <h3>
            Tratamiento
            { ` (Nro. ${this.state.id_tra})`}
          </h3>
            {this.state.form.estado==1? 
            <span class="badge text-bg-success">Activo</span>
            :
            <span class="badge text-bg-danger">Finalizado</span>
            }

          <div className="row">
            <div className="col-md-11">

              <div className="box box-warning direct-chat direct-chat-warning">
                <div className="box-header with-border">
                  <h3 className="box-title " >
                    <div style={{display:"flex"}}>
                    Nombre: &nbsp;
                    <NuInputEdit 
                            type="text"                           
                            className="form-control" 
                            name="nombre" 
                            value={this.state.form.nombre}
                            onChange={this.handleChangeForm }
                            onOkInput={this.handleOKInput }
                            valtipo='string2'
                    />
                    &nbsp;
                    <span class="badge text-bg-info">{ this.state.form.fecha }</span>
                    </div>
                  </h3>
                  
                  <div className="box-tools pull-right">

                    <button type="button" className="btn btn-box-tool" data-widget="collapse">
                      <i className="fa fa-minus"></i>
                    </button>

                  </div>
                </div>

                <div className="box-body" style={{ padding: "0" }}>

                  <div className="row">
                    <div className="col-md-12 col-sm-12 col-lg-12 ">

                      <div id="grafic_window" className="dash-widget1 p-1 m-0"
                      style={{ height:405}}>
                        {/*    */}
                        
                         
                        <Odontograma 
                          data={this.state.data}
                          onClickPieza={ this.onClickPieza }
                        />
                          
                      </div>

                    </div>
                  </div>

                </div>

                {/*<div className="box-footer">
                
                </div>*/}

              </div>

            </div>
          
          </div>
          
          <div className="row">  
            {/*  ------------------------------------------   */}
            <div className="col-md-11">

              <div className="box box-warning direct-chat direct-chat-warning">
                <div className="box-header with-border">
                  <h3 className="box-title">Presupuesto</h3>
                  <div className="box-tools pull-right">

                    <button type="button" className="btn btn-success"  onClick={ this.realizar_pago }>
                      <i className="fa fa-plus"></i> Pago
                    </button>
                    <button type="button" className="btn btn-warning " onClick={ this.agregar_row }>
                      <i className="fa fa-edit"></i>Nuevo
                    </button>

                  </div>
                </div>

                <div className="box-body">
                  {/*    */}
                  <div className="table-responsive">
                    <table id="tabla01" className=" etigridb2" cellSpacing="0" style={{width:"100%"}}>
                      <thead>
                        <tr>
                          <th style={{ width: "15px", padding: "6px"}}></th>

                          <th>PRESTACION</th>
                          <th>PIEZAS</th>
                          <th>aux</th>
                          <th>colorb1</th>
                          <th>CANT</th>
                          <th>PRECIO</th>
                          <th>REALIZADO</th>
                          <th>TOTAL</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {/*
                        {
    "id_tradet": 129,
    "fecha": "2025-10-16",
    "id_prod": 5,
    "nombre_p": "EXODONCIA",
    "pieza": "25",
    "partes": "00000",
    "id_medico": 0,
    "color": "#ff0000",
    "interno_sn": 0,
    "cant": 1,
    "precio": 35,
    "descu": 0,
    "total": 35,
    "id_tra": 17,
    "realizado_sn": 0
} */}
                      { this.state.data.map((item,index) => (
                        <tr key={index}>
                          <td style={{ backgroundColor: item.color }}></td>
                          <td>{item.nombre_p}</td>
                          <td style={{ color:"red", textAlign: "center" }}>{item.pieza}</td>
                          <td style={{ color:"red", textAlign: "center" }}>{item.partes}</td>
                          <td >{item.colorb1 }</td>
                          <td style={{ textAlign:"right" }}>{item.cant}</td>
                          <td style={{ textAlign:"right" }}>{item.precio}</td>
                          
                          <td >
                            <div className="form-check form-switch" style={{display: "flex", justifyContent: "center"}}>
                              <input className="form-check-input" type="checkbox" role="switch" 
                                  name="realizado_sn"
                                  value = {item.realizado_sn }
                                  checked={item.realizado_sn ===1 }
                                  onChange={(e)=>this.handleChangeSwitch(e,item.id_tradet)}  
                              />
                            </div>
                          </td>
                          <td style={{ textAlign:"right" }}>{item.total}</td>
                          <td>
                            <Button className="btn-sm btn-warning" onClick={ ()=>this.editar_row(item.id_tradet) }><i className="fa fa-pencil"></i></Button>
                            <Button className="btn-sm btn-danger" onClick={ ()=>this.eliminar_row(item.id_tradet) }><i className="fa fa-trash"></i></Button>
                          </td>
                        </tr>
                      ))}
                      </tbody>

                    </table>
                  </div>
                  {/*    */}

                </div>

                <div className="box-footer" >
                 
                </div>


              </div>

              <div className="" style={{float: "right"}}>
                <table id="tabla01" className=" tabla_plomo " cellSpacing="0">
                  <thead>

                  </thead>
                  <tbody>

                    <tr>
                      <td>Total presupuesto</td>
                      <td style={{ textAlign: "right" }}><b>{this.state.form.mtotal}</b></td>
                    </tr>
                    <tr>
                      <td>Abonado</td>
                      <td style={{ textAlign: "right" }}>{this.state.form.pagado}</td>
                    </tr>
                    <tr>
                      <td>Saldo</td>
                      <td style={{ textAlign: "right", color: "red" }}>{this.state.form.saldo}</td>
                    </tr>

                  </tbody>

                </table>
              </div>

            </div>
            {/*  --------------------------------------------   */}
           
          </div>

          <div className="row">
            
          </div>

      

        </section>

        <TratamientoDetModal 
            ref={this.modalRef}
            id_tra={ this.state.id_tra }
            okModal={ this.okModal}
            closeModal={ this.closeModal}
        />
        <PagoModal
            ref={this.modalRefPago}
            okModal={ this.okModalPago}
            closeModal={ this.closeModalPago}
            
        />
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>


    );
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim( Tratamiento);